import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notify } from '@/ui/snackbar/notify';
import { performLogout } from '@/helpers/logout-utils';

import { jwtTokenState } from '../auth.state';
import { useSetAtom } from 'jotai';

export const useLogout = () => {
  const { t } = useTranslation('default');
  const queryClient = useQueryClient();
  const setToken = useSetAtom(jwtTokenState);

  const mutation = useMutation({
    mutationFn: async () => {
      await performLogout({
        queryClient,
        setToken,
        skipDescopeLogout: false,
      });
    },
    onError: () => {
      notify({
        message: t`unknownError`,
      });
    },
  });

  return () => mutation.mutateAsync();
};
